import contentTemplate from 'properties/main/mobile-margin.ejs';
import BasePropertyView from 'BasePropertyView.js';
import constants from 'Constants';
import mobileMargin from '../../../mobile/commons/MobileMargins';
import eventBus from '../../../service/EventBus';
class MobileMainMarginsView extends BasePropertyView {

    initialize(opts) {
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};

        this.events = {
            'click .margin-optionButton': 'setMargin'
        };

        this.listenTo(eventBus, constants.EV_UPDATE_MARGIN, this.updateSelectedMargin);
        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    setSelectedOption() {
        let selectedOption = mobileMargin.getSelectedOption(this.model.attributes, 5);      
        $(`svg[data-margin=${selectedOption}]`).addClass("selected");
    }

    setMargin(ev) {
        ev.preventDefault();
        this.updateSelectedMargin(ev.currentTarget);
    }

    updateSelectedMargin(currentTarget) {
        let marginsToApply = currentTarget.getAttribute("data-margin").split("-");        
        $(".margin-optionButton").removeClass("selected");
        this.model.set('~margins', marginsToApply);
    }

    render() {
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));
        this.setSelectedOption();
        this.delegateEvents();
        return this;
    }
}

export default MobileMainMarginsView;